/* eslint-disable no-param-reassign */
import { ColumnElement } from '@typedream/core';
import { DreamWithOverride } from '../../plate';
import { ELEMENT_COLUMN } from '../../pluginKeys';
import { normalizeColumn } from './normalizers/normalizeColumn';

export const withColumn: DreamWithOverride = (editor) => {
  const { normalizeNode } = editor;

  editor.normalizeNode = (entry) => {
    const [node, path] = entry;

    if (
      node.type === ELEMENT_COLUMN
      && normalizeColumn(editor, [node as ColumnElement, path])
    ) {
      return;
    }

    normalizeNode(entry);
  };

  return editor;
};
